




























import Icon from '@/packages/ae-icon';
import Button from '@/packages/d-button';
import message from '@/packages/d-message';
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

Vue.use(message);
Vue.use(Button);
Vue.use(Icon);
@Component({
  name: 'CodeBox'
})
export default class CodeBox extends Vue {
  @Prop(String)
  public code: string;
  @Prop(String)
  public markdown: string;
  public showCode = false;

  public copied() {
    this.$message.success('已复制');
  }
}
